<template>
  <div class="privacy-policy">
    <h1>Privacy Policy for Eye.Academy</h1>
    <p>Last Updated: 13/04/2024</p>
    <p>
      Welcome to Eye.Academy. We are committed to protecting your personal
      information and your right to privacy. If you have any questions or
      concerns about this privacy policy, or our practices with regards to your
      personal information, please contact us at
      <a href="mailto:team@eye.academy">team@eye.academy</a>.
    </p>
    <p>
      When you visit our website Eye.Academy (the "Website"), and more
      generally, use any of our services (the "Services", which include the
      Website), we appreciate that you are trusting us with your personal
      information. We take your privacy very seriously. In this privacy policy,
      we seek to explain to you in the clearest way possible what information we
      collect, how we use it, and what rights you have in relation to it. We
      hope you take some time to read through it carefully, as it is important.
      If there are any terms in this privacy policy that you do not agree with,
      please discontinue use of our Services immediately.
    </p>

    <section
      v-for="(section, index) in privacyPolicySections"
      :key="index"
    >
      <h2 class="mt-6">{{ section.title }}</h2>
      <p>{{ section.description }}</p>
      <ul>
        <li
          v-for="(subSection, subIndex) in section.subSections"
          :key="`subSection-${subIndex}`"
        >
          <strong>{{ subSection.subTitle }}</strong>
          <p>{{ subSection.content }}</p>
        </li>
      </ul>
    </section>

    <p class="mt-6">
      If you have questions or comments about this policy, you may email us at
      <a href="mailto:team@eye.academy">team@eye.academy</a>.
    </p>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        privacyPolicySections: [
          {
            title: "1. What Information Do We Collect?",
            description:
              "We collect personal information that you voluntarily provide to us when registering at the Website, expressing an interest in obtaining information about us or our products and services, when participating in activities on the Website, or otherwise contacting us. The personal information that we collect depends on the context of your interactions with us and the Website, the choices you make, and the products and features you use.",
            subSections: [
              {
                subTitle: "Personal Information Provided by You.",
                content:
                  "We collect names; phone numbers; email addresses; mailing addresses; job titles; usernames; passwords; contact preferences; contact or authentication data; billing addresses; and other similar information.",
              },
              {
                subTitle: "Payment Data.",
                content:
                  "We collect data necessary to process your payment if you make purchases. This includes your payment instrument number (such as a credit card number), and the security code associated with your payment instrument. All payment data is securely stored and processed by Stripe, our payment processor.",
              },
            ],
          },
          {
            title: "2. How Do We Use Your Information?",
            description:
              "We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent. We use the information we collect or receive to facilitate account creation and logon process, to send you marketing and promotional communications, to send administrative information to you, and for other business purposes.",
            subSections: [],
          },
          {
            title: "3. Will Your Information Be Shared With Anyone?",
            description:
              "We only share information with your consent, to comply with laws, to protect your rights, or to fulfill business obligations.",
            subSections: [],
          },
          {
            title: "4. Do We Use Cookies and Other Tracking Technologies?",
            description:
              "We may use cookies and other tracking technologies to collect and store your information.",
            subSections: [],
          },
          {
            title: "5. How Long Do We Keep Your Information?",
            description:
              "We keep your information for as long as necessary to fulfill the purposes outlined in this privacy policy unless otherwise required by law.",
            subSections: [],
          },
          {
            title: "6. How Do We Keep Your Information Safe?",
            description:
              "We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process.",
            subSections: [],
          },
          {
            title: "7. Do We Collect Information from Minors?",
            description:
              "We do not knowingly collect data from or market to children under 18 years of age.",
            subSections: [],
          },
          {
            title: "8. What Are Your Privacy Rights?",
            description:
              "You may review, change, or terminate your account at any time.",
            subSections: [],
          },
          {
            title: "9. Controls for Do-Not-Track Features",
            description:
              "Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected.",
            subSections: [],
          },
          {
            title: "10. Do We Make Updates to This Policy?",
            description:
              "Yes, we will update this policy as necessary to stay compliant with relevant laws.",
            subSections: [],
          },
        ],
      };
    },
  };
</script>

<style scoped>
  .privacy-policy {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .privacy-policy h1,
  .privacy-policy h2 {
    color: #333;
  }

  .privacy-policy p,
  .privacy-policy li {
    color: #666;
  }

  .privacy-policy a {
    color: #007bff;
  }

  .privacy-policy ul {
    list-style-type: none;
    padding: 0;
  }

  .privacy-policy li {
    margin-bottom: 10px;
  }

  .privacy-policy li strong {
    display: block;
  }
</style>
